import type { TourSection } from './types';

export const adminClientsListSections: TourSection[] = [
  {
    id: 'overview',
    label: 'Qué son los Clientes B2B',
    steps: [
      {
        target: '[data-tour="clients-header"]',
        title: 'Clientes B2B',
        content:
          'Cada cliente representa una aplicación externa (ej: tienda online, app móvil de un distribuidor) que se conecta al catálogo. Cada uno tiene su llave de acceso, sus permisos, y reglas propias de cómo recibe la información.',
      },
    ],
  },
  {
    id: 'filters',
    label: 'Buscar y filtrar',
    steps: [
      {
        target: '[data-tour="clients-filters"]',
        title: 'Filtros del listado',
        content:
          'Buscar por nombre o slug, y filtrar por tipo (interno / externo), permisos y estado. Los filtros de permisos tienen 3 estados: con permiso, sin permiso, o cualquiera.',
      },
    ],
  },
  {
    id: 'table',
    label: 'Listado',
    steps: [
      {
        target: '[data-tour="clients-table"]',
        title: 'Tabla de clientes',
        content:
          'Cada fila muestra el tipo, los permisos principales y el estado. Click en el nombre abre el detalle con todas las configuraciones disponibles.',
      },
    ],
  },
  {
    id: 'create',
    label: 'Crear cliente nuevo',
    steps: [
      {
        target: '[data-tour="clients-new"]',
        title: 'Nuevo cliente B2B',
        content:
          'Al crear un cliente, el sistema genera una clave de acceso (API Key) que se muestra UNA SOLA VEZ en pantalla. Cópiala inmediatamente — después solo verás una versión enmascarada por seguridad.',
      },
    ],
  },
];
